import React from 'react';
import { DatePicker, Modal } from 'antd';
import { AddedAttribute, AddedAttributeType } from 'pages/UserPage/components/MiddlePane/types';
import { Dayjs } from 'dayjs';
import { formatAsDateString, toDayjs } from 'common/utils/time';
import { updateSingletonStartOrEndTime } from '../../../updateAttributeValueUtils';

interface Props {
  attribute: AddedAttribute;
  attributeTypeName: string;
  isStartTimePicker: boolean;
  setUserAttributeTypes: (userAttributeTypes: AddedAttributeType[]) => void;
  userAttributeTypes: AddedAttributeType[];
}

const displayDate = (attribute: AddedAttribute, isStartTimePicker: boolean): Dayjs | null => {
  if (attribute?.start_date) {
    if (isStartTimePicker) {
      return toDayjs(attribute.start_date);
    }
    if (attribute?.end_date) {
      return toDayjs(attribute.end_date);
    }
  }
  return null;
};

const StartOrEndTimePicker = ({
  attribute,
  attributeTypeName,
  isStartTimePicker,
  userAttributeTypes,
  setUserAttributeTypes,
}: Props) => (
  <DatePicker
    onChange={e => {
      try {
        updateSingletonStartOrEndTime(
          attributeTypeName,
          userAttributeTypes,
          setUserAttributeTypes,
          attribute.value,
          isStartTimePicker,
          e ? formatAsDateString(e) : undefined,
          attribute.start_date,
          attribute.end_date
        );
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      catch (err: any) {
        Modal.error({
          content: err.toString(),
          title: 'Error',
        });
      }
    }}
    value={displayDate(attribute, isStartTimePicker)}
  />
);

export default StartOrEndTimePicker;
